<template>
    <div class="m-cont">
        <div class="header-section">
            <div class="title-row">
                <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                <h1 class="page-title">MAGAZZINO</h1>
                <div class="total-box">
                    <span class="total-label">Valore Totale:</span>
                    <span class="total-value">{{ totaleMagazzino }} €</span>
                </div>
                <div class="search-box">
                    <input type="text" v-model="searchQuery" placeholder="Cerca prodotto..." class="filter-input-magazzino">
                </div>
            </div>
        </div>    
        
        <div class="tab-cont" id="style-3">
            <table class="table" >
                <thead class="thead-dark">
                    <tr>
                        <th class="text">Prodotto</th>
                        <th class="text">Quantità</th>
                        <th class="text">Quantità Min</th>
                         <th class="text">Quantità Da Ordinare</th>
                        <th class="text">€/100 gr</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(prodotto, index) in filteredProdotti" :key="index">
                            <td class="text pointer" ><input v-model="prodotto.descrizio" disabled /></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.quantita" @input="()=> updateQuantita(prodotto.code,prodotto.quantita,null,null)"/></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.quantitamin" @input="()=> updateQuantita(prodotto.code,null,prodotto.quantitamin,null)"/></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.quantitaordine" @input="()=> updateQuantita(prodotto.code,null,null,prodotto.quantitaordine)"/></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.prezzo" @input="()=> updatePrezzo(prodotto.code,prodotto.prezzo)"/></td>
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
</template>






<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'TabellaMapP',
  data: function () {
            return {
                prodotti:[],
                quantita:'',
                searchQuery: '',
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
                this.prodotti = []; // Clear list to avoid duplicates
                response.data.messaggio.forEach(element => {
                      element.prezzo=element.prezzo?element.prezzo:0;
                      element.quantitamin=element.quantitamin?element.quantitamin:0; 
                      element.quantitaordine=element.quantitaordine?element.quantitaordine:0;
                      element.stato=element.stato?element.stato:'';
                      this.prodotti.push(element);
                });
            }else{console.log('Non è stato possibile caricare i prodotti')}
        })
    },
    updateQuantita(code,quantita,quantitamin,quantitaordine) {
        this.axios.post(this.store.path+'updateQuantita',{code:code,quantita:quantita,quantitamin:quantitamin,quantitaordine:quantitaordine,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
    updatePrezzo(code,prezzo) {
        this.axios.post(this.store.path+'updatePrezzo',{code:code,prezzo:prezzo,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
  },
  computed: {
    filteredProdotti() {
        if (!this.prodotti) return [];
        const query = (this.searchQuery || '').toLowerCase().trim();
        if (!query) return this.prodotti;
        
        return this.prodotti.filter(prodotto => {
            const desc = (prodotto.descrizio || '').toLowerCase();
            const nome = (prodotto.nome || '').toLowerCase();
            const code = (prodotto.code || '').toLowerCase();
            return desc.includes(query) || nome.includes(query) || code.includes(query);
        });
    },
    totaleMagazzino() {
        if (!this.prodotti) return 0;
        const total = this.prodotti.reduce((acc, prodotto) => {
            const qta = parseFloat(prodotto.quantita) || 0;
            const prezzo = parseFloat(prodotto.prezzo) || 0;
            return acc + (qta * (prezzo / 100));
        }, 0);
        return total.toFixed(2);
    }
  },
  
  beforeMount() {
      this.displayProduct();
  },
  
}
</script>



<style scoped>
.m-cont {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f8f9fa;
}

.header-section {
    padding: 20px;
    background: white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.title-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
}

.tab-cont {
    flex-basis: 80%;
    overflow-y: scroll;
    padding: 10px;
    background: #F5F5F5;
    width: 100vw;
}

.table-responsive-wrapper {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    overflow: hidden;
}

.table {
    width: 100%;
    margin-bottom: 0;
    border-collapse: collapse;
}

.thead-dark th {
    position: sticky;
    top: 0;
    background-color: #343a40;
    color: white;
    z-index: 10;
    padding: 12px;
    white-space: nowrap;
}

td {
    padding: 10px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
}

td input {
    width: 100%;
    max-width: 120px;
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}

@media (max-width: 600px) {
    .title-row {
        flex-direction: column;
        gap: 10px;
    }
    
    .table th, .table td {
        padding: 8px;
        font-size: 0.9rem;
    }
    
    td input {
        max-width: 80px;
    }
}

.search-box {
    margin-left: auto;
}

.filter-input-magazzino {
    width: 100%;
    max-width: 300px;
    padding: 8px 15px;
    border: 1px solid #ced4da;
    border-radius: 20px;
    font-size: 0.9em;
    outline: none;
    transition: border-color 0.2s;
}

.filter-input-magazzino:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.total-box {
    background: #eaffee;
    padding: 8px 15px;
    border-radius: 10px;
    border: 1px solid #c3e6cb;
    display: flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.total-label {
    font-size: 0.9rem;
    color: #155724;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.total-value {
    font-size: 1.2rem;
    color: #28a745;
    font-weight: 800;
}
</style>